export const CONSUMER_ADD = 'CONSUMER_ADD';
